// @ts-nocheck
/**
 * ツインキーパッシブタイプ定義
 *
 * 仕様書: twin_key_passive_system_v1.md
 * 設計書: twin_key_phase2_design.md
 */

/**
 * パッシブスロット
 * - パッシブ1: ★0（初期解放）- 個性枠
 * - パッシブ2: ★1 - 成長枠
 * - パッシブ3: ★2 - 成長枠
 * - 究極パッシブ: ★3 - 最終枠・特別感
 */
export const PASSIVE_SLOTS = {
  PASSIVE_1: 'PASSIVE_1',
  PASSIVE_2: 'PASSIVE_2',
  PASSIVE_3: 'PASSIVE_3',
  ULTIMATE: 'ULTIMATE',
};

/**
 * パッシブスロット解放条件（覚醒段階）
 */
export const PASSIVE_UNLOCK_REQUIREMENTS = {
  [PASSIVE_SLOTS.PASSIVE_1]: 0,  // ★0（初期）
  [PASSIVE_SLOTS.PASSIVE_2]: 1,  // ★1
  [PASSIVE_SLOTS.PASSIVE_3]: 2,  // ★2
  [PASSIVE_SLOTS.ULTIMATE]: 3,   // ★3
};

/**
 * パッシブ発動タイミング
 */
export const PASSIVE_TRIGGER_TYPES = {
  ALWAYS: 'ALWAYS',                   // 常時
  CONDITIONAL: 'CONDITIONAL',         // 条件付き
  BATTLE_START: 'BATTLE_START',       // 戦闘開始時
  ON_ACTION: 'ON_ACTION',             // 行動時（攻撃/スキル使用時）
  ON_DAMAGE_RECEIVED: 'ON_DAMAGE_RECEIVED',  // 被弾時
  ON_KILL: 'ON_KILL',                 // 撃破時
  ALLY_SUPPORT: 'ALLY_SUPPORT',       // 味方支援
  TURN_START: 'TURN_START',           // ターン開始時
  TURN_END: 'TURN_END',               // ターン終了時
};

/**
 * パッシブ効果タイプ
 */
export const PASSIVE_EFFECT_TYPES = {
  // ステータス補正
  ATK_PERCENT: 'ATK_PERCENT',         // 攻撃力%
  HP_PERCENT: 'HP_PERCENT',           // HP%
  DEF_FLAT: 'DEF_FLAT',               // 防御固定値
  SPD_FLAT: 'SPD_FLAT',               // 速度固定値
  CRIT_RATE: 'CRIT_RATE',             // クリティカル率

  // 戦闘効果
  DAMAGE_DEALT_PERCENT: 'DAMAGE_DEALT_PERCENT',     // 与ダメージ%
  DAMAGE_RECEIVED_PERCENT: 'DAMAGE_RECEIVED_PERCENT', // 被ダメージ%
  HEAL_PERCENT: 'HEAL_PERCENT',       // 回復効果%

  // 特殊効果
  STATUS_INFLICT_CHANCE: 'STATUS_INFLICT_CHANCE',   // 状態異常付与確率
  STATUS_RESIST: 'STATUS_RESIST',     // 状態異常耐性
  BUFF_APPLY: 'BUFF_APPLY',           // バフ付与
  HP_RECOVER: 'HP_RECOVER',           // HP回復
  EXTRA_ACTION: 'EXTRA_ACTION',       // 追加行動
  COUNTER_ATTACK: 'COUNTER_ATTACK',   // 反撃
  IGNORE_DEF: 'IGNORE_DEF',           // 防御無視
  EXECUTE: 'EXECUTE',                 // 即死
  REVIVE: 'REVIVE',                   // 復活
  SHIELD: 'SHIELD',                   // シールド
  INVINCIBLE: 'INVINCIBLE',           // 無敵
  SURVIVE: 'SURVIVE',                 // 根性（致死ダメージ耐え）
  DAMAGE_CAP: 'DAMAGE_CAP',           // ダメージ上限
  FIRST_STRIKE: 'FIRST_STRIKE',       // 先制
  COPY_PASSIVE: 'COPY_PASSIVE',       // パッシブコピー
  ADAPT: 'ADAPT',                     // 適応（連続攻撃ダメージ減少）
};

/**
 * 条件タイプ
 */
export const PASSIVE_CONDITION_TYPES = {
  HP_BELOW: 'HP_BELOW',               // HP〇%以下
  HP_ABOVE: 'HP_ABOVE',               // HP〇%以上
  ALLY_COUNT: 'ALLY_COUNT',           // 味方〇体以上
  ENEMY_COUNT: 'ENEMY_COUNT',         // 敵〇体以上
  ALLY_ATTRIBUTE: 'ALLY_ATTRIBUTE',   // 味方に〇属性がいる
  ENEMY_ATTRIBUTE: 'ENEMY_ATTRIBUTE', // 敵に〇属性がいる
  TURN_NUMBER: 'TURN_NUMBER',         // 〇ターン目以降
  FIRST_ACTION: 'FIRST_ACTION',       // 最初の行動
  MY_TURN: 'MY_TURN',                 // 自分のターン
};

/**
 * 基準数値（パッシブスロット別）
 */
export const PASSIVE_BASE_VALUES = {
  // 常時発動系
  always: {
    [PASSIVE_SLOTS.PASSIVE_1]: 0.10,  // +10%
    [PASSIVE_SLOTS.PASSIVE_2]: 0.15,  // +15%
    [PASSIVE_SLOTS.PASSIVE_3]: 0.20,  // +20%
    [PASSIVE_SLOTS.ULTIMATE]: 0.30,   // +30% or 特殊
  },
  // 条件発動系（常時より高め）
  conditional: {
    [PASSIVE_SLOTS.PASSIVE_1]: 0.20,  // +20%
    [PASSIVE_SLOTS.PASSIVE_2]: 0.30,  // +30%
    [PASSIVE_SLOTS.PASSIVE_3]: 0.40,  // +40%
    [PASSIVE_SLOTS.ULTIMATE]: 0.50,   // +50% or 特殊
  },
  // 確率発動系
  probability: {
    [PASSIVE_SLOTS.PASSIVE_1]: 0.10,  // 10%
    [PASSIVE_SLOTS.PASSIVE_2]: 0.15,  // 15%
    [PASSIVE_SLOTS.PASSIVE_3]: 0.20,  // 20%
    [PASSIVE_SLOTS.ULTIMATE]: 0.30,   // 30% or 確定
  },
};

/**
 * 究極パッシブ特殊効果プリセット
 */
export const ULTIMATE_PASSIVE_PRESETS = {
  // 攻撃系
  DOUBLE_ACTION: {
    name: '2回行動',
    description: '20%で同じターンにもう1回行動',
    trigger: PASSIVE_TRIGGER_TYPES.ON_ACTION,
    effect: PASSIVE_EFFECT_TYPES.EXTRA_ACTION,
    probability: 0.20,
  },
  CONFIRMED_CRIT: {
    name: '確定クリティカル',
    description: 'HP30%以下の敵に確定クリ',
    trigger: PASSIVE_TRIGGER_TYPES.ON_ACTION,
    effect: PASSIVE_EFFECT_TYPES.CRIT_RATE,
    condition: { type: PASSIVE_CONDITION_TYPES.HP_BELOW, target: 'enemy', value: 0.30 },
    value: 1.0,
  },
  PURSUIT: {
    name: '追撃',
    description: '攻撃時、追加で攻撃力×30%ダメージ',
    trigger: PASSIVE_TRIGGER_TYPES.ON_ACTION,
    effect: PASSIVE_EFFECT_TYPES.DAMAGE_DEALT_PERCENT,
    value: 0.30,
  },
  PENETRATION: {
    name: '貫通',
    description: '防御を50%無視',
    trigger: PASSIVE_TRIGGER_TYPES.ALWAYS,
    effect: PASSIVE_EFFECT_TYPES.IGNORE_DEF,
    value: 0.50,
  },
  EXECUTION: {
    name: '処刑',
    description: 'HP20%以下の敵に即死判定（30%）',
    trigger: PASSIVE_TRIGGER_TYPES.ON_ACTION,
    effect: PASSIVE_EFFECT_TYPES.EXECUTE,
    condition: { type: PASSIVE_CONDITION_TYPES.HP_BELOW, target: 'enemy', value: 0.20 },
    probability: 0.30,
  },
  MULTI_STRIKE: {
    name: '連撃',
    description: '通常攻撃が2回になる',
    trigger: PASSIVE_TRIGGER_TYPES.ON_ACTION,
    effect: PASSIVE_EFFECT_TYPES.EXTRA_ACTION,
    condition: { type: 'normal_attack' },
    value: 1,
  },

  // 防御系
  INVINCIBLE_START: {
    name: '無敵',
    description: '戦闘開始時1ターン無敵',
    trigger: PASSIVE_TRIGGER_TYPES.BATTLE_START,
    effect: PASSIVE_EFFECT_TYPES.INVINCIBLE,
    duration: 1,
  },
  REFLECT: {
    name: '反射',
    description: '受けたダメージの30%を反射',
    trigger: PASSIVE_TRIGGER_TYPES.ON_DAMAGE_RECEIVED,
    effect: PASSIVE_EFFECT_TYPES.COUNTER_ATTACK,
    value: 0.30,
  },
  DAMAGE_LIMIT: {
    name: 'ダメージ上限',
    description: '1回の被ダメージ上限を最大HPの30%に',
    trigger: PASSIVE_TRIGGER_TYPES.ALWAYS,
    effect: PASSIVE_EFFECT_TYPES.DAMAGE_CAP,
    value: 0.30,
  },
  GUTS: {
    name: '根性',
    description: 'HP1以上なら致死ダメージを1回耐える',
    trigger: PASSIVE_TRIGGER_TYPES.ON_DAMAGE_RECEIVED,
    effect: PASSIVE_EFFECT_TYPES.SURVIVE,
    usesPerBattle: 1,
  },
  COVER: {
    name: 'かばう',
    description: 'HP低い味方への攻撃を自動でかばう',
    trigger: PASSIVE_TRIGGER_TYPES.ALLY_SUPPORT,
    effect: 'COVER',
  },
  BARRIER: {
    name: 'バリア',
    description: '戦闘開始時、最大HP30%分のシールド',
    trigger: PASSIVE_TRIGGER_TYPES.BATTLE_START,
    effect: PASSIVE_EFFECT_TYPES.SHIELD,
    value: 0.30,
  },

  // 回復系
  REVIVE_SELF: {
    name: '復活',
    description: '戦闘中1回、HP1%で復活',
    trigger: PASSIVE_TRIGGER_TYPES.ON_DAMAGE_RECEIVED,
    effect: PASSIVE_EFFECT_TYPES.REVIVE,
    value: 0.01,
    usesPerBattle: 1,
  },
  LIFESTEAL: {
    name: '吸収',
    description: '与ダメージの20%をHP回復',
    trigger: PASSIVE_TRIGGER_TYPES.ON_ACTION,
    effect: PASSIVE_EFFECT_TYPES.HP_RECOVER,
    value: 0.20,
    source: 'damage_dealt',
  },
  SUPER_REGEN: {
    name: '超再生',
    description: 'ターン終了時HP10%回復',
    trigger: PASSIVE_TRIGGER_TYPES.TURN_END,
    effect: PASSIVE_EFFECT_TYPES.HP_RECOVER,
    value: 0.10,
    source: 'max_hp',
  },
  HEAL_BOOST: {
    name: '回復強化',
    description: '受ける回復効果+50%',
    trigger: PASSIVE_TRIGGER_TYPES.ALWAYS,
    effect: PASSIVE_EFFECT_TYPES.HEAL_PERCENT,
    value: 0.50,
  },
  NEAR_DEATH_HEAL: {
    name: '瀕死回復',
    description: 'HP20%以下になった時、1回だけHP50%回復',
    trigger: PASSIVE_TRIGGER_TYPES.CONDITIONAL,
    condition: { type: PASSIVE_CONDITION_TYPES.HP_BELOW, target: 'self', value: 0.20 },
    effect: PASSIVE_EFFECT_TYPES.HP_RECOVER,
    value: 0.50,
    source: 'max_hp',
    usesPerBattle: 1,
  },

  // 支援系
  PARTY_ATK_AURA: {
    name: '全体バフ',
    description: '味方全体の攻撃+15%',
    trigger: PASSIVE_TRIGGER_TYPES.ALWAYS,
    target: 'allies',
    effect: PASSIVE_EFFECT_TYPES.ATK_PERCENT,
    value: 0.15,
  },
  PARTY_DEF_AURA: {
    name: 'オーラ',
    description: '味方全体の被ダメージ-10%',
    trigger: PASSIVE_TRIGGER_TYPES.ALWAYS,
    target: 'allies',
    effect: PASSIVE_EFFECT_TYPES.DAMAGE_RECEIVED_PERCENT,
    value: -0.10,
  },
  INSPIRE: {
    name: '鼓舞',
    description: '味方が倒れた時、生存者の攻撃+20%',
    trigger: PASSIVE_TRIGGER_TYPES.ALLY_SUPPORT,
    effect: PASSIVE_EFFECT_TYPES.ATK_PERCENT,
    value: 0.20,
    condition: { type: 'ally_defeated' },
  },
  INHERITANCE: {
    name: '継承',
    description: '自分が倒れた時、味方1体にバフ全移譲',
    trigger: PASSIVE_TRIGGER_TYPES.ON_DAMAGE_RECEIVED,
    effect: 'TRANSFER_BUFFS',
    condition: { type: 'self_defeated' },
  },

  // 特殊系
  WEAK_IMMUNITY: {
    name: '弱点無効',
    description: '属性相性の不利を無効化',
    trigger: PASSIVE_TRIGGER_TYPES.ALWAYS,
    effect: 'WEAK_IMMUNITY',
  },
  STATUS_IMMUNITY: {
    name: '状態異常無効',
    description: '特定の状態異常を無効化',
    trigger: PASSIVE_TRIGGER_TYPES.ALWAYS,
    effect: PASSIVE_EFFECT_TYPES.STATUS_RESIST,
    value: 1.0,
    statusTypes: ['FREEZE', 'STUN', 'PARALYSIS'],
  },
  FIRST_STRIKE: {
    name: '先制',
    description: '必ず最初に行動',
    trigger: PASSIVE_TRIGGER_TYPES.ALWAYS,
    effect: PASSIVE_EFFECT_TYPES.FIRST_STRIKE,
  },
  GUARANTEED_COUNTER: {
    name: 'カウンター',
    description: '被弾時100%で反撃',
    trigger: PASSIVE_TRIGGER_TYPES.ON_DAMAGE_RECEIVED,
    effect: PASSIVE_EFFECT_TYPES.COUNTER_ATTACK,
    probability: 1.0,
    value: 0.50,
  },
  FORTITUDE: {
    name: '不屈',
    description: '状態異常のターン数-1',
    trigger: PASSIVE_TRIGGER_TYPES.ALWAYS,
    effect: 'STATUS_DURATION_REDUCE',
    value: 1,
  },
  ADAPT: {
    name: '適応',
    description: '同じ敵からの連続攻撃ダメージ-20%ずつ',
    trigger: PASSIVE_TRIGGER_TYPES.ON_DAMAGE_RECEIVED,
    effect: PASSIVE_EFFECT_TYPES.ADAPT,
    value: 0.20,
  },
  COPY: {
    name: 'コピー',
    description: '戦闘開始時、ランダムな敵のパッシブ1つをコピー',
    trigger: PASSIVE_TRIGGER_TYPES.BATTLE_START,
    effect: PASSIVE_EFFECT_TYPES.COPY_PASSIVE,
    count: 1,
  },
};

/**
 * ヘルパー関数: パッシブスロットが解放されているか確認
 */
export const isPassiveUnlocked = (slot, awakening) => {
  const required = PASSIVE_UNLOCK_REQUIREMENTS[slot];
  return awakening >= required;
};

/**
 * ヘルパー関数: 解放済みパッシブスロット一覧取得
 */
export const getUnlockedSlots = (awakening) => {
  return Object.entries(PASSIVE_UNLOCK_REQUIREMENTS)
    .filter(([_, required]) => awakening >= required)
    .map(([slot]) => slot);
};
